import React, { FC, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AppNav } from './AppNav';
import { UserMenu } from './UserMenu';
import { AppContext } from '../../contexts/AppContext';
import { isAdminOrBlockitAdmin } from '../PrivateRoute';
import { useBlockitThemeContext } from '../../../../themes/ThemeContext';

const AppHeaderStyles = styled.div<{ shadowColor?: string; textOnDark?: string; navBg?: string; isAlluvium?: boolean }>`
  box-shadow: ${({ isAlluvium, shadowColor }) =>
    isAlluvium ? '0 1px 3px rgba(0, 0, 0, 0.1)' : `0 1px 2px ${shadowColor || 'rgba(125, 167, 212, 1)'}`};
  font-family: 'Source Sans Pro', sans-serif;
  line-height: ${({ isAlluvium }) => (isAlluvium ? '1.5' : 'inherit')};

  .app-header {
    display: flex;
    align-items: flex-end;
    background-color: ${({ navBg, theme }) => navBg || theme.primaryColor};
    box-sizing: border-box;
    color: ${({ textOnDark }) => textOnDark || '#fff'};
    height: ${({ isAlluvium }) => (isAlluvium ? '55px' : '73px')};
    padding: 0 20px;
    white-space: nowrap;

    .logo {
      display: flex;
      align-items: center;
      align-self: ${({ isAlluvium }) => (isAlluvium ? 'center' : 'stretch')};
      text-align: left;
    }
  }
`;

export const AppHeader: FC<{}> = (): JSX.Element => {
  const { currentOrganization, mode, switchMode } = useContext(AppContext);
  const { branding, isAlluvium } = useBlockitThemeContext();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get('tab');

  useEffect(() => {
    if (mode === 'admin' && !isAdminOrBlockitAdmin(currentOrganization)) {
      switchMode('referral');
    }
  }, [currentOrganization, mode, switchMode]);

  const logoWidth = branding.logoWidth;

  return (
    <AppHeaderStyles
      shadowColor={isAlluvium ? 'rgba(0, 0, 0, 0.1)' : undefined}
      textOnDark={isAlluvium ? '#402728' : undefined}
      navBg={isAlluvium ? branding.headerPrimaryBg : undefined}
      isAlluvium={isAlluvium}
    >
      <UserMenu activeTab={activeTab} />
      <div className="app-header">
        <div className="logo">
          <Link to="/">
            <img
              src={branding.logoPath}
              alt={isAlluvium ? 'Alluvium' : 'Blockit'}
              style={{ width: logoWidth, flexShrink: 0 }}
            />
          </Link>
        </div>
        <AppNav />
      </div>
    </AppHeaderStyles>
  );
};
